export const local = (state) => {
  return state.local;
};



// WEBPACK FOOTER //
// ./src/store/getters.js